<template>
  <div>
    <el-button @click="AddPatient" type="primary" v-if="type == 1">+新增患者</el-button>
    <!-- <el-link @click="AddPatient" type="primary" :underline="false" v-if="type == 2"><i class="el-icon-edit-outline"></i>修改</el-link> -->
    <div class="add_dialog">
      <el-dialog :visible.sync="AddPatientDialog" width="1121px" top="1vh" v-dialogDrag @close="Patientcancel"
        custom-class="customWidth">
        <div slot="title" class="header-title">
          <span class="title-name"></span>
          <span class="title-age" v-if="type == 1">新增患者</span>
          <span class="title-age" v-if="type == 2">修改信息</span>
        </div>
        <el-form label-width="170px" :model="formLabelAlign" ref="formLabelAlign" :rules="rules">
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="所属项目:">
                <el-select v-model="formLabelAlign.ProjectId" placeholder="请选择" :disabled="flag">
                  <el-option v-for="(item, index) in BelongingProject" :key="index" :label="item.Name" :value="item.Id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <!-- <el-col :span="12">
              <el-form-item label="医保卡号:">
                <el-input v-model="formLabelAlign.MiCardNo"></el-input>
              </el-form-item>
            </el-col> -->
            <el-col :span="12">
              <el-form-item label="医保卡号:">
                <el-input v-model="formLabelAlign.MiCardNo"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="患者编号:">
                <el-input v-model="formLabelAlign.No"></el-input>
              </el-form-item>
            </el-col>
            <!-- <el-col :span="12">
              <el-form-item label="医保卡号:">
                <el-input v-model="formLabelAlign.MiCardNo"></el-input>
              </el-form-item>
            </el-col> -->
            <el-col :span="12">
              <el-form-item label="就诊日期:">
                <el-date-picker type="date" placeholder="选择日期" size="mini" v-model="formLabelAlign.VisitDate"
                  value-format="yyyy-MM-dd">
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="患者姓名:">
                <el-input v-model="formLabelAlign.Name"></el-input>
              </el-form-item>
            </el-col>
            <!-- <el-col :span="12">
              <el-form-item label="就诊日期:">
                <el-date-picker
                  type="date"
                  placeholder="选择日期"
                  size="mini"
                  v-model="formLabelAlign.VisitDate"
                  value-format="yyyy-MM-dd"
                >
                </el-date-picker>
              </el-form-item>
            </el-col> -->

            <el-col :span="12">
              <el-form-item label="手术日期:">
                <el-date-picker type="date" placeholder="选择日期" size="mini" v-model="formLabelAlign.OperationDate"
                  value-format="yyyy-MM-dd">
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="姓名缩写:">
                <el-input v-model="formLabelAlign.NameAbbr"></el-input>
              </el-form-item>
            </el-col>
            <!-- <el-col :span="12">
              <el-form-item label="风险等级:">
                <el-select placeholder="请选择" v-model="formLabelAlign.RiskRating">
                  <el-option :label="item.Name" :value="item.Code" v-for="(item,index) in RiskLevel" :key="index"></el-option>
                </el-select>
              </el-form-item>
            </el-col> -->

            <el-col :span="12">
              <el-form-item label="风险等级:">
                <el-select placeholder="请选择" v-model="formLabelAlign.RiskRating">
                  <el-option :label="item.Name" :value="item.Code" v-for="(item, index) in RiskLevel"
                    :key="index"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <!-- prop="Tel" -->
              <el-form-item label="患者电话:">
                <el-input maxlength="11" v-model="formLabelAlign.Tel" style="width: 360px"></el-input>
              </el-form-item>
            </el-col>
            <!-- <el-col :span="12">
              <el-form-item label="住院病区:">
                <el-input v-model="formLabelAlign.Ward"></el-input>
              </el-form-item>
            </el-col> -->
            <el-col :span="12">
              <el-form-item label="住院病区:">
                <el-input v-model="formLabelAlign.Ward"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="微信:">
                <el-input v-model="formLabelAlign.WX"></el-input>
              </el-form-item>
            </el-col>
            <!-- <el-col :span="12">
              <el-form-item label="住院天数:">
                <el-input v-model="formLabelAlign.Day"></el-input>
              </el-form-item>
            </el-col> -->

            <el-col :span="12">
              <el-form-item label="住院天数:">
                <el-input v-model="formLabelAlign.Day"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="证件类型:">
                <el-select placeholder="请选择" v-model="formLabelAlign.CertType">
                  <el-option :label="item.Name" :value="item.Code" v-for="(item, index) in DocumentType"
                    :key="index"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <!-- <el-col :span="12">
              <el-form-item label="出院日期:">
                <el-date-picker
                  type="date"
                  placeholder="选择日期"
                  size="mini"
                  v-model="formLabelAlign.DischargeDate"
                   value-format="yyyy-MM-dd"
                >
                </el-date-picker>
              </el-form-item>
            </el-col> -->
            <el-col :span="12">
              <el-form-item label="出院日期:">
                <el-date-picker type="date" placeholder="选择日期" size="mini" v-model="formLabelAlign.DischargeDate"
                  value-format="yyyy-MM-dd">
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <!-- prop="CertNo" -->
              <el-form-item label="证件号码:">
                <el-input maxlength="18" v-model="formLabelAlign.CertNo" @change="CertNoChange"></el-input>
              </el-form-item>
            </el-col>
            <!-- <el-col :span="12">
              <el-form-item label="出院诊断:">
                <el-input v-model="formLabelAlign.DischargeDiagnosis"></el-input>
              </el-form-item>
            </el-col> -->
            <el-col :span="12">
              <el-form-item label="出院诊断:">
                <el-input v-model="formLabelAlign.DischargeDiagnosis"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="出生日期:">
                <el-date-picker type="date" placeholder="选择日期" size="mini" v-model="formLabelAlign.Birthday"
                  value-format="yyyy-MM-dd">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <!-- <el-col :span="12">
              <el-form-item label="出院方式:">
                <el-select placeholder="请选择" v-model="formLabelAlign.DischargeMode">
                  <el-option :label="item.Name" :value="item.Code" v-for="(item,index) in DischargeMode" :key="index"></el-option>
                </el-select>
              </el-form-item>
            </el-col> -->
            <el-col :span="12">
              <el-form-item label="次要诊断:">
                <el-input v-model="formLabelAlign.SecondaryDiagnosis"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="年龄:">
                <el-input v-model="formLabelAlign.Age" style="width: 330px"></el-input>
                <span>岁</span>
              </el-form-item>
            </el-col>
            <!-- <el-col :span="12">
              <el-form-item label="主治医生:">
                <el-input v-model="formLabelAlign.AttendingDoctor"></el-input>
              </el-form-item>
            </el-col> -->
            <el-col :span="12">
              <el-form-item label="出院方式:">
                <el-select placeholder="请选择" v-model="formLabelAlign.DischargeMode">
                  <el-option :label="item.Name" :value="item.Code" v-for="(item, index) in DischargeMode"
                    :key="index"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="性别:">
                <el-radio-group v-model="formLabelAlign.Sex">
                  <el-radio label="1">男</el-radio>
                  <el-radio label="0">女</el-radio>
                  <!-- <el-radio label="不详">不详</el-radio> -->
                </el-radio-group>
              </el-form-item>
            </el-col>
            <!-- <el-col :span="12">
              <el-form-item label="随访医生:">
                <el-input v-model="formLabelAlign.FollowUpDoctor"></el-input>
              </el-form-item>
            </el-col> -->
            <el-col :span="12">
              <el-form-item label="主治医生:">
                <el-input v-model="formLabelAlign.AttendingDoctor"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="身高:">
                <el-input v-model="formLabelAlign.Height" style="width: 330px"></el-input>
                <span>m</span>
              </el-form-item>
            </el-col>
            <!-- <el-col :span="12">
              <el-form-item label="教育程度">
                <el-select placeholder="请选择" v-model="formLabelAlign.Edu">
                  <el-option :label="item.Name" :value="item.Code" v-for="(item,index) in Educationallevel" :key="index"></el-option>
                </el-select>
              </el-form-item>
            </el-col> -->
            <el-col :span="12">
              <el-form-item label="随访医生:">
                <el-input v-model="formLabelAlign.FollowUpDoctor"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="体重:">
                <el-input v-model="formLabelAlign.Weight" style="width: 330px"></el-input>
                <span>kg</span>
              </el-form-item>
            </el-col>
            <!-- <el-col :span="12">
              <el-form-item label="随机号:">
                <el-input v-model="formLabelAlign.RandomNumber"></el-input>
              </el-form-item>
            </el-col> -->
            <el-col :span="12">
              <el-form-item label="教育程度">
                <el-select placeholder="请选择" v-model="formLabelAlign.Edu">
                  <el-option :label="item.Name" :value="item.Code" v-for="(item, index) in Educationallevel"
                    :key="index"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="患者QQ:">
                <el-input v-model="formLabelAlign.QQ"></el-input>
              </el-form-item>
            </el-col>
            <!-- <el-col :span="12">
              <el-form-item label="组别号:">
                <el-input v-model="formLabelAlign.GroupNumber"></el-input>
              </el-form-item>
            </el-col> -->
            <el-col :span="12">
              <el-form-item label="随机号:">
                <el-input v-model="formLabelAlign.RandomNumber" :disabled="IsRtc == false"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="紧急联系人姓名:">
                <el-input v-model="formLabelAlign.EcName" style="width: 360px"></el-input>
              </el-form-item>
            </el-col>
            <!-- <el-col :span="12">
              <el-form-item label="患者来源:">
                <el-select placeholder="请选择" v-model="formLabelAlign.Source">
                  <el-option :label="item.Name" :value="item.Code" v-for="(item,index) in PatientSource" :key="index"></el-option>
                </el-select>
              </el-form-item>
            </el-col> -->
            <el-col :span="12">
              <el-form-item label="组别号:">
                <el-input v-model="formLabelAlign.GroupNumber" :disabled="IsRtc == false"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="紧急联系人电话">
                <el-input v-model="formLabelAlign.EcTel" style="width: 360px"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="患者来源:">
                <el-select placeholder="请选择" v-model="formLabelAlign.Source">
                  <el-option :label="item.Name" :value="item.Code" v-for="(item, index) in PatientSource"
                    :key="index"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="入院方式:">
                <el-select placeholder="请选择" v-model="formLabelAlign.AdmissionMode">
                  <el-option :label="item.Name" :value="item.Code" v-for="(item, index) in AdmissionMode"
                    :key="index"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="患者地址:">
                <el-input v-model="formLabelAlign.Address" />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div class="btn">
          <button @click="Patientcancel">取消</button>
          <button @click="PatientSubmit">提交</button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import PatientCenter from "../../api/PatientCenter"
import ProjectManagement from "../../api/ProjectManagement"
import derive from "../../api/derive"
import { validatePhone, validateregId } from "../../utils/verification"
import { local } from "../../utils/storage"
let addFormData = {
  ProjectId: null,
  No: null,
  MiCardNo: null,
  Name: null,
  NameAbbr: null,
  Sex: null,
  Birthday: null,
  Age: null,
  Tel: null,
  Height: null,
  Weight: null,
  WX: null,
  QQ: null,
  CertType: '00',
  CertNo: null,
  Edu: null,
  EcName: null,
  EcTel: null,
  VisitDate: null,
  RiskRating: '01',
  Ward: null,
  Day: null,
  DischargeDate: null,
  DischargeDiagnosis: null,
  DischargeMode: null,
  FollowUpDoctor: null,
  RandomNumber: null,
  GroupNumber: null,
  Source: null,
  Address: null,
  ProjectUnitId: null,
  OperationDate: null,
  SecondaryDiagnosis: null
}
export default {
  data() {
    return {
      flag: false,
      Name: [
        { required: true },
      ],
      Tel: [
        { required: true },
      ],
      No: [
        { required: true },
      ],
      AddPatientDialog: false,
      formLabelAlign: JSON.parse(JSON.stringify(addFormData)),
      RiskLevel: [],//风险等级
      DocumentType: [],//证件类型
      Educationallevel: [],//教育程度
      PatientSource: [],//患者来源
      DischargeMode: [],//出院方式
      BelongingProject: [],//所属项目
      Company: [],//单位
      rules: {
        Tel: [
          { validator: validatePhone, trigger: 'blur', required: true }
        ],
        CertNo: [
          { validator: validateregId, trigger: 'blur' }
        ],
        Name: [
          { required: true, message: '患者姓名不能为空!', trigger: 'blur' }
        ],
        No: [
          { required: true, message: '患者编号不能为空!', trigger: 'blur' }
        ],
      },
      IsRtc: local.get('IsRtc'),
      //判断电话号码和身份证是否改变
      TelIsChange: '',
      CertNoIsChange: ''
    }
  },
  props: ["type", "item", "project", "dialog"],
  created() {
    // alert(this.IsRtc)
    // if(this.project!='all'){
    //   console.log(this.project,"$$$$");
    //    this.formLabelAlign.ProjectId=this.project
    // }
    // if(this.$route.query.Id!=null){
    //   this.flag=true
    //    this.formLabelAlign.ProjectId=this.$route.query.Id
    // }
    if (this.item != null) {
      this.BasicData();
      this.AddPatientDialog = this.dialog;
      this.formLabelAlign = JSON.parse(JSON.stringify(this.item));
      this.TelIsChange = this.item.Tel;
      this.CertNoIsChange = this.item.CertNo;
    }
  },
  methods: {
    // TelChang(e){
    //      validatePhone(e)
    // },
    //根据身份证获取出生日期,年龄,性别
    CertNoChange(e) {
      this.formLabelAlign.Birthday = this.IdCard(e, 1)
      this.formLabelAlign.Age = this.IdCard(e, 3)
      this.formLabelAlign.Sex = this.IdCard(e, 2)
    },
    IdCard(IdCard, type) {
      if (type === 1) {
        //获取出生日期
        let birthday = IdCard.substring(6, 10) + "-" + IdCard.substring(10, 12) + "-" + IdCard.substring(12, 14)
        return birthday
      }
      if (type === 2) {
        //获取性别
        if (parseInt(IdCard.substr(16, 1)) % 2 === 1) {
          return "1"
        } else {
          return "0"
        }
      }
      if (type === 3) {
        //获取年龄
        var ageDate = new Date()
        var month = ageDate.getMonth() + 1
        var day = ageDate.getDate()
        var age = ageDate.getFullYear() - IdCard.substring(6, 10) - 1
        if (IdCard.substring(10, 12) < month || IdCard.substring(10, 12) === month && IdCard.substring(12, 14) <= day) {
          age++
        }
        if (age <= 0) {
          age = 1
        }
        return age
      }
    },

    Patientcancel() {
      // this.$nextTick(()=>{
      //   this.$refs[formName].resetFields();
      // })
      this.formLabelAlign = {};
      this.$store.commit("dialogFlagFn", false);
      this.AddPatientDialog = false;
    },
    //打开患者中心新增患者弹框
    AddPatient() {
      this.IsRtc = local.get('IsRtc')
      this.AddPatientDialog = true
      //  this.formLabelAlign={}
      this.formLabelAlign = {
        ProjectId: null,
        No: null,
        MiCardNo: null,
        Name: null,
        NameAbbr: null,
        Sex: null,
        Birthday: null,
        Age: null,
        Tel: null,
        Height: null,
        Weight: null,
        WX: null,
        QQ: null,
        CertType: '00',
        CertNo: null,
        Edu: null,
        EcName: null,
        EcTel: null,
        VisitDate: null,
        RiskRating: '01',
        Ward: null,
        Day: null,
        DischargeDate: null,
        DischargeDiagnosis: null,
        DischargeMode: null,
        FollowUpDoctor: null,
        RandomNumber: null,
        GroupNumber: null,
        Source: null,
        Address: null,
        ProjectUnitId: null,
        OperationDate: null,
        SecondaryDiagnosis: null,
        AdmissionMode: null,
      }
      if (this.$route.query.Id != null) {
        this.flag = true
        this.formLabelAlign.ProjectId = this.$route.query.Id
      }
      this.BasicData()
    },
    //提交前的表单校验
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          alert('submit!');
        } else {
          return false;
        }
      })
    },

    Vaild() {
      ProjectManagement.EditProjectPatientData(this.formLabelAlign).then(res => {
        if (res.data.Status == 1) {
          this.$emit("EditSonToFather", res.data.Data)
          this.$message({
            message: res.data.Message,
            type: 'success'
          });
          this.AddPatientDialog = false
        } else {
          alert(res.data.Message)
        }
      })
    },
    //新增患者
    PatientSubmit() {
      if (this.type == 1) {
        // console.log(this.formLabelAlign.ProjectId);
        if (this.formLabelAlign.ProjectId == null) {
          this.$message({
            showClose: true,
            message: '所属项目、患者姓名为必填项。患者编号和患者电话至少填写一项',
            type: 'warning',
            duration: 0
          });
          return
        };
        // if(this.formLabelAlign.Name==null&&this.formLabelAlign.Tel==null){
        //   alert("姓名和电话为必填项")
        //   return
        // };
        if (this.formLabelAlign.Name == null) {
          this.$message({
            showClose: true,
            message: '所属项目、患者姓名为必填项。患者编号和患者电话至少填写一项',
            type: 'warning',
            duration: 0
          });
          return
        };
        if (!this.formLabelAlign.No && !this.formLabelAlign.Tel) {
          // alert("所属项目、所属姓名为必填项。患者编号和患者电话至少填写一项")
          this.$message({
            showClose: true,
            message: '所属项目、患者姓名为必填项。患者编号和患者电话至少填写一项',
            type: 'warning',
            duration: 0
          });
          return
        };
        // 身高体重判断
        let { Weight } = this.formLabelAlign
        let { Height } = this.formLabelAlign
        let BoolWeight = false
        if (Weight <= 0 || Weight >= 500 || Weight == null) {
          BoolWeight = true
        }
        let BoolHeight = false
        if (Height <= 0 || Height >= 3 || Height == null) {
          BoolHeight = true
        }
        if (Boolean(Height) && Boolean(Weight) && BoolWeight && BoolHeight) {
          this.$message({
            showClose: true,
            message: '请填写正确的身高和体重，注意此处单位是米和千克！',
            type: 'warning',
            duration: 0
          });
          return
        }
        if (Boolean(Weight) && BoolWeight) {
          this.$message({
            showClose: true,
            message: '请填写正确的体重，注意此处单位是千克！',
            type: 'warning',
            duration: 0
          });
          return
        }
        if (Boolean(Height) && BoolHeight) {
          this.$message({
            showClose: true,
            message: '请填写正确的身高，注意此处单位是米',
            type: 'warning',
            duration: 0
          });
          return
        }
        if (this.formLabelAlign.Tel) {
          var reg_tel = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
          if (!reg_tel.test(this.formLabelAlign.Tel)) {
            // alert("请输入正确手机号");
            this.$message({
              showClose: true,
              message: '请输入正确的手机号码',
              type: 'warning',
              duration: 0
            });
            return
          };
        };
        if (this.formLabelAlign.No) {
          var reg = new RegExp("[\\u4E00-\\u9FFF]+", "g");
          if (reg.test(this.formLabelAlign.No)) {
            this.$message({
              showClose: true,
              message: '患者编号中不能含有中文',
              type: 'warning',
              duration: 0
            });
            return;
          }
        };


        ProjectManagement.AddProjectPatientData(this.formLabelAlign).then(res => {
          if (res.data.Status == 1) {
            this.$emit("AddSonToFather", res.data.Data)
            this.$message({
              message: res.data.Message,
              type: 'success'
            });
            this.AddPatientDialog = false
          } else {
            alert(res.data.Message)
          }
        })
        return
      }
      if (this.type == 2) {
        if (!this.formLabelAlign.No && !this.formLabelAlign.Tel) {
          alert("患者编号和患者电话至少填写一项！")
          return
        };
        // 身高体重判断
        let { Weight } = this.formLabelAlign
        let { Height } = this.formLabelAlign
        let BoolWeight = false
        if (Weight <= 0 || Weight >= 500 || Weight == null) {
          BoolWeight = true
        }
        let BoolHeight = false
        if (Height <= 0 || Height >= 3 || Height == null) {
          BoolHeight = true
        }
        if (Boolean(Height) && Boolean(Weight) && BoolWeight && BoolHeight) {
          this.$message({
            showClose: true,
            message: '请填写正确的身高和体重，注意此处单位是米和千克',
            type: 'warning',
            duration: 0
          });
          return
        }
        if (Boolean(Weight) && BoolWeight) {
          this.$message({
            showClose: true,
            message: '请填写正确的体重，注意此处的单位是千克！',
            type: 'warning',
            duration: 0
          });
          return
        }
        if (Boolean(Height) && BoolHeight) {
          this.$message({
            showClose: true,
            message: '请填写正确的身高，注意此处单位是米',
            type: 'warning',
            duration: 0
          });
          return
        }
        this.Vaild();

        //提交前的校验
        // if(this.formLabelAlign.Tel != this.TelIsChange && this.formLabelAlign.CertNo == this.CertNoIsChange){
        //   this.$refs.formLabelAlign.validateField('Tel',(valid)=>{
        //     if(!valid){
        //       this.formLabelAlign.CertNo = '';
        //       this.Vaild();
        //     }
        //   })
        // }else if(this.formLabelAlign.Tel == this.TelIsChange && this.formLabelAlign.CertNo != this.CertNoIsChange){
        //   this.$refs.formLabelAlign.validateField('CertNo',(valid)=>{
        //     if(!valid){
        //       this.formLabelAlign.Tel = '';
        //       this.Vaild();
        //     }
        // })
        // }else if(this.formLabelAlign.Tel == this.TelIsChange && this.formLabelAlign.CertNo == this.CertNoIsChange){
        //   this.formLabelAlign.Tel = '';
        //   this.formLabelAlign.CertNo = '';
        //   this.Vaild();
        // }else{
        //   this.$refs.formLabelAlign.validateField('CertNo',(valid)=>{
        //     if(!valid){
        //       this.$refs.formLabelAlign.validateField('Tel',(valid1)=>{
        //         if(!valid1){
        //           this.Vaild();
        //       }
        //     })
        //     }
        //   })
        // };
        // this.TelIsChange = '';
        // this.CertNoIsChange= '';


        // this.$refs.formLabelAlign.validate((valid) => {
        //     if(valid){
        //       ProjectManagement.EditProjectPatientData(this.formLabelAlign).then(res=>{
        //         if(res.data.Status==1){
        //           this.$emit("EditSonToFather",this.formLabelAlign)
        //           this.$message({
        //             message: res.data.Message,
        //             type: 'success'
        //           });
        //           this.AddPatientDialog=false
        //         }else{
        //           alert(res.data.Message)
        //         }
        //           console.log(res,"修改项目患者");
        //       });
        //     } else {
        //       this.$message({
        //         message:'还有内容未填写完成',
        //         type:'warning'
        //       })
        //       return false;
        //     }
        // })


        // ProjectManagement.EditProjectPatientData(this.formLabelAlign).then(res=>{
        //       if(res.data.Status==1){
        //         this.$emit("EditSonToFather",this.formLabelAlign)
        //         this.$message({
        //           message: res.data.Message,
        //           type: 'success'
        //         });
        //         this.AddPatientDialog=false
        //      }else{
        //        alert(res.data.Message)
        //      }
        //         console.log(res,"修改项目患者");
        // })
        // return
      }
    },
    BasicData() {
      // 入院方式
      const AdmissionMode = "RYFS"
      PatientCenter.BaseDataBigData(AdmissionMode).then(res => {
        if (res.data.Status == 1) {
          this.AdmissionMode = res.data.Data
        } else {
          alert(res.data.Message)
        }
      })
      //所属项目
      derive.ProjectListData().then(res => {
        if (res.data.Status == 1) {
          this.BelongingProject = res.data.Data
        } else {
          alert(res.data.Message)
        }
      })
      //风险等级
      const RiskLevel = "FXDJ"
      PatientCenter.BaseDataBigData(RiskLevel).then(res => {
        if (res.data.Status == 1) {
          this.RiskLevel = res.data.Data
        } else {
          alert(res.data.Message)
        }
      })
      //证件类型
      const DocumentType = "ZJLX"
      PatientCenter.BaseDataBigData(DocumentType).then(res => {
        if (res.data.Status == 1) {
          this.DocumentType = res.data.Data
        } else {
          alert(res.data.Message)
        }
      })
      //教育程度
      const Educationallevel = "JYCD"
      PatientCenter.BaseDataBigData(Educationallevel).then(res => {
        if (res.data.Status == 1) {
          this.Educationallevel = res.data.Data
        } else {
          alert(res.data.Message)
        }
      })
      //患者来源
      const PatientSource = "HZLY"
      PatientCenter.BaseDataBigData(PatientSource).then(res => {
        if (res.data.Status == 1) {
          this.PatientSource = res.data.Data
        } else {
          alert(res.data.Message)
        }
      })
      //出院方式
      const DischargeMode = "CYFS"
      PatientCenter.BaseDataBigData(DischargeMode).then(res => {
        if (res.data.Status == 1) {
          this.DischargeMode = res.data.Data
        } else {
          alert(res.data.Message)
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
/deep/.el-col {
  height: 50px;
}

.add_dialog {
  /deep/.el-dialog {
    .el-dialog__body {
      padding-top: 10px;
    }

    .el-dialog__header {
      margin-bottom: 0;
    }

    /deep/.el-form {
      .el-input {
        width: 360px;
      }

      .el-input__inner {
        width: 360px;
      }

      .el-select {
        .el-input__inner {
          width: 360px;
        }
      }
    }

    .btn {
      margin-top: 0;
    }
  }
}

@media screen and (-webkit-min-device-pixel-ratio: 1.5) {

  /deep/ .el-dialog {
    width: 96% !important;

    .el-form-item {
      .el-form-item__label {
        width: 160px !important;
      }

      .el-form-item__content {
        margin-left: 160px !important;

        .el-input__inner {
          width: 145px !important;
        }

        .el-input {
          width: 145px !important;
        }
      }
    }


  }

}
</style>
